
import { InvoiceSummaryComponent } from './modules/financials/components/invoice-summary/invoice-summary.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { DataEntryGuard } from './core/guards/data-entry.guard';
import { FinancialGuard } from './core/guards/financial.guard';
import { LawyerGuard } from './core/guards/lawyer.guard';
import { PrintRollsComponent } from './modules/print/print-rolls/print-rolls.component';
import { AdminLayoutComponent } from './shared/layouts/admin-layout/admin-layout.component';
import { PrintLayoutComponent } from './modules/print/print-layout/print-layout.component';
import { PrintCaseSessionsComponent } from './modules/print/print-case-sessions/print-case-sessions.component';
import { PrintCaseSessionComponent } from './modules/print/print-case-session/print-case-session.component';
import { PrintExpertSessionsComponent } from './modules/print/print-expert-sessions/print-expert-sessions.component';
import { PrintExpertSessionComponent } from './modules/print/print-expert-session/print-expert-session.component';
import { PrintTimesheetComponent } from './modules/print/print-timesheet/print-timesheet.component';
import { PrintFileSummaryComponent } from './modules/print/print-file-summary/print-file-summary.component';
import { PrintFilesReportComponent } from './modules/print/print-files-report/print-files-report.component';
import { PrintClientsComponent } from './modules/print/print-clients/print-clients.component';
import { PrintClientSummaryComponent } from './modules/print/print-client-summary/print-client-summary.component';
import { PrintClientContactsComponent } from './modules/print/print-client-contacts/print-client-contacts.component';
import { PrintClientBankDetailsComponent } from './modules/print/print-client-bank-details/print-client-bank-details.component';
import { PrintClientContractsComponent } from './modules/print/print-client-contracts/print-client-contracts.component';
import { PrintClientPartnersComponent } from './modules/print/print-client-partners/print-client-partners.component';
import { PrintInvoiceSummaryComponent } from './modules/print/print-invoice-summary/print-invoice-summary.component';
import { TimesheetGuard } from './core/guards/timesheet.guard';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: './modules/authentication/authentication.module#AuthenticationModule'
  },
  {
    path: 'print',
    outlet: 'print',
    component: PrintLayoutComponent,
    children: [
      { path: 'rolls', component: PrintRollsComponent },
      { path: 'case-sessions', component: PrintCaseSessionsComponent },
      { path: 'case-session', component: PrintCaseSessionComponent },
      { path: 'exp-sessions', component: PrintExpertSessionsComponent },
      { path: 'exp-session', component: PrintExpertSessionComponent },
      { path: 'file-summary', component: PrintFileSummaryComponent },
      { path: 'files-report', component: PrintFilesReportComponent },
      { path: 'clients', component: PrintClientsComponent },
      { path: 'client-summary', component: PrintClientSummaryComponent },
      { path: 'client-contacts', component: PrintClientContactsComponent },
      { path: 'client-bank', component: PrintClientBankDetailsComponent },
      { path: 'client-contracts', component: PrintClientContractsComponent },
    ]
  },
  {
    path: 'print/invoice',
    outlet: 'print',
    component: PrintInvoiceSummaryComponent
  },
  {
    path: 'print/timesheet',
    outlet: 'print',
    component: PrintTimesheetComponent
  },
  {
    path: '', component: AdminLayoutComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      {
        path: 'dashboard',
        loadChildren: './modules/dashboard/dashboard.module#DashboardModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'chat',
        loadChildren: './modules/chat/chat.module#ChatModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'users',
        loadChildren: './modules/users/users.module#UsersModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'clients',
        loadChildren: './modules/clients/clients.module#ClientsModule',
        canActivateChild: [DataEntryGuard],
      },
      {
        path: 'files',
        loadChildren: './modules/files/files.module#FilesModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'rolls',
        loadChildren: './modules/rolls/rolls.module#RollsModule',
        canActivate: [AuthGuard, DataEntryGuard]
      },
      {
        path: 'financials',
        loadChildren: './modules/financials/financials.module#FinancialsModule',
        canActivate: [AuthGuard, FinancialGuard]
      },
      {
        path: 'calendar',
        loadChildren: './modules/calendar/calendar.module#CalendarModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'profile',
        loadChildren: './modules/profile/profile.module#ProfileModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'settings',
        loadChildren: './modules/settings/settings.module#SettingsModule',
        canActivate: [AuthGuard, DataEntryGuard]
      },
      {
        path: 'timesheet',
        loadChildren: './modules/timesheet/timesheet.module#TimesheetModule',
        canActivate: [AuthGuard, TimesheetGuard]
      },
      { path: '**', pathMatch: 'full', redirectTo: 'dashboard' }
    ]
  },
];


@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
